export function AlarmHeader() {
  return <div className="flex h-9 items-center">Alarm Events</div>;
}

export default AlarmHeader;
